import React from "react";
import { ContentGrid, Grid3, SectionBox } from "../styles";
import { Card, Button, Field, Pill } from "../components";
import Icon from "../components/Icon";

const KYBView = ({
  companyName,
  setCompanyName,
  companyVat,
  setCompanyVat,
  companyRegNo,
  setCompanyRegNo,
  kybVeriffStatus,
  setKybVeriffStatus,
  veriffSessionId,
  setVeriffSessionId,
  verificationUrl,
  setVerificationUrl,
  veriffMode,
  setVeriffMode,
  pushToast,
  uid,
  setAudit,
}) => {
  const createVeriffSession = async (mode) => {
    await new Promise((r) => setTimeout(r, 450));
    const sessionId = "vf_" + uid().slice(0, 10);
    const verificationUrl = "https://veriff.com/verify/" + sessionId + "?mode=" + mode;
    return { sessionId, verificationUrl };
  };

  const startVeriff = async (mode) => {
    setVeriffMode(mode);
    if (mode === "kyc") {
      // This is KYB view, but keeping structure
    } else {
      setKybVeriffStatus("in_progress");
    }

    const { sessionId, verificationUrl } = await createVeriffSession(mode);
    setVeriffSessionId(sessionId);
    setVerificationUrl(verificationUrl);

    pushToast("KYB", "Veriff session created");
    setAudit((s) => [{ id: uid(), ts: "2026-01-08 09:20", actor: "system", type: "KYB", detail: "Veriff session created: " + sessionId, severity: "med" }, ...s]);
  };

  const simulateVeriffCallback = async (mode, decision) => {
    await new Promise((r) => setTimeout(r, 800));
    if (mode === "kyb") {
      setKybVeriffStatus(decision);
    }
    pushToast("KYB", "Decision: " + decision);
    setAudit((s) => [{ id: uid(), ts: "2026-01-08 09:21", actor: "system", type: "KYB", detail: "Veriff decision: " + decision, severity: decision === "approved" ? "low" : "high" }, ...s]);
  };

  return (
    <ContentGrid>
      <Card title="KYB (Company) • Veriff" icon="shield" right={<Pill tone={kybVeriffStatus === "approved" ? "d" : kybVeriffStatus === "in_progress" ? "c" : "b"}>{kybVeriffStatus.replace("_", " ")}</Pill>}>
        <ContentGrid>
          <div style={{ fontSize: 12, color: "rgba(210,235,245,.78)" }}>Business verification is separate from personal KYC. Create a KYB session server-side and redirect the user to Veriff.</div>
          <Grid3>
            <Field label="Company legal name" value={companyName} onChange={setCompanyName} />
            <Field label="Registration no." value={companyRegNo} onChange={setCompanyRegNo} />
            <Field label="VAT / Tax ID" value={companyVat} onChange={setCompanyVat} />
          </Grid3>
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
            <Button variant="sec" disabled={kybVeriffStatus === "in_progress"} onClick={() => void startVeriff("kyb")} icon="check">
              Create KYB session
            </Button>
            <Button disabled={kybVeriffStatus !== "in_progress"} onClick={() => void simulateVeriffCallback("kyb", "approved")}>Mock approve</Button>
            <Button variant="danger" disabled={kybVeriffStatus !== "in_progress"} onClick={() => void simulateVeriffCallback("kyb", "rejected")}>Mock reject</Button>
          </div>
          <SectionBox>
            <div style={{ fontWeight: 900 }}>Last session</div>
            <div style={{ fontSize: 12, color: "rgba(210,235,245,.78)" }}>SessionId: <b style={{ color: "rgba(240,250,255,.92)" }}>{veriffSessionId || "—"}</b></div>
            <div style={{ fontSize: 12, color: "rgba(210,235,245,.78)" }}>verificationUrl: <b style={{ color: "rgba(240,250,255,.92)" }}>{verificationUrl || "—"}</b></div>
          </SectionBox>
        </ContentGrid>
      </Card>
    </ContentGrid>
  );
};

export default KYBView;
